// The engine's address for the web app. On Yelo's own domain (yelodubai.com - owner, 4 Nov 2026) the page and the
// engine share one address: the server passes /api to the engine, so the browser calls it as the same site (no CORS,
// nothing on the engine to allow). Anywhere else (yelo-dubai-management.web.app, localhost) REACT_APP_FINES_API_URL,
// as before.
export const YELO_HOSTS = ['yelodubai.com', 'www.yelodubai.com'];

export function apiBase(env = process.env.REACT_APP_FINES_API_URL,
    host = (typeof window !== 'undefined' ? window.location.hostname : '')) {
    if (YELO_HOSTS.includes(String(host || '').toLowerCase())) return '/api';
    return (env || 'http://127.0.0.1:8000/api').replace(/\/$/, '');
}
